import { axios } from "lib/axios";
import { useQuery } from "react-query";

export const getGovernDetails = () => {
  return axios.get(`/pages/slug/governance`);
};

export const useGovernDetails = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["governDetails"],
    queryFn: () => getGovernDetails(),
  });
};
